import type { TimeZone } from '@iheartjane/types';
import { timezone as parseApiTimezones } from '@iheartjane/utils';
import dayjs from 'dayjs';
import type { Dayjs, OptionType } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import type { Time } from '@jane/shared/types';

dayjs.extend(advancedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const parseTime = (
  time: Time | number,
  timezone: TimeZone,
  format?: OptionType
): Dayjs =>
  typeof time === 'number' && time.toString().length === 10
    ? dayjs.unix(time).tz(parseApiTimezones(timezone))
    : dayjs(time, format).tz(parseApiTimezones(timezone));

export const parseCurrentTime = (timezone: TimeZone): Dayjs =>
  dayjs().tz(parseApiTimezones(timezone));
